module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Cooking/Chef-adca66486982c599d5792759c7287a88ebf990ac421ddfe04cf756030cf39ae1.svg";